"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _Editions = require("self-service-api/constants/Editions");

var _GrowthSuiteCatalogModal = _interopRequireDefault(require("pricing-pages-unified-ui/components/growth-suite-catalog/GrowthSuiteCatalogModal"));

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _publicPageUrls = require("pricing-pages-unified-ui/utils/publicPageUrls");

var _queryParamUtils = require("../../utils/queryParamUtils");

var SuiteViewAllFeatures = function SuiteViewAllFeatures(_ref) {
  var edition = _ref.edition,
      currencyCode = _ref.currencyCode;

  var _useState = (0, _react.useState)(edition === _Editions.STARTER && (0, _queryParamUtils.getQueryParams)().viewStarterFeatures === true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isModalOpen = _useState2[0],
      setIsModalOpen = _useState2[1];

  var gaClassName = (0, _publicPageUrls.getGAClassName)("growth" + edition + "-pricing-features");

  var toggleViewAllFeaturesModal = function toggleViewAllFeaturesModal() {
    setIsModalOpen(!isModalOpen);

    if (!isModalOpen) {
      (0, _getUsageTracker.default)().track('clickToViewModal', {
        name: 'compare-feature-modal',
        edition: edition,
        inCalculator: false
      });
    }
  };

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_UIButton.default, {
    className: "m-left-0 " + gaClassName,
    onClick: toggleViewAllFeaturesModal,
    use: "link"
  }, _react.default.createElement(_FormattedMessage.default, {
    className: gaClassName,
    message: "pricingPage.highlightedMerchCards.seeAllFeatures"
  })), isModalOpen && _react.default.createElement(_GrowthSuiteCatalogModal.default, {
    edition: edition,
    onCloseClick: toggleViewAllFeaturesModal,
    currencyCode: currencyCode
  }));
};

SuiteViewAllFeatures.propTypes = {
  edition: _propTypes.default.string,
  currencyCode: _propTypes.default.string
};
var _default = SuiteViewAllFeatures;
exports.default = _default;
module.exports = exports.default;